import { render, staticRenderFns } from "./WaterRenamed.vue?vue&type=template&id=64a93b97&scoped=true"
import script from "./WaterRenamed.vue?vue&type=script&lang=js"
export * from "./WaterRenamed.vue?vue&type=script&lang=js"
import style0 from "./WaterRenamed.vue?vue&type=style&index=0&id=64a93b97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a93b97",
  null
  
)

export default component.exports